// POM-6148: presentational pieces of the Split Order By Quantity dialog, kept here so the
// dialog itself stays under the max-lines cap.
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Grid, Typography } from '@mui/material';
import { lighten } from '@mui/material/styles';
import PropTypes from 'prop-types';

// Same muted-label treatment the reship dialog uses for its label/value pairs.
export const mutedLabel = (theme) => lighten(theme.palette.text.primary, 0.3);

// The footer note beside Split Order, and the dialog's only running total now that the
// Fills now / Fills later tiles are gone. Tinted and iconed so the outcome of confirming
// reads as information the user should take in, not as fine print. Full width above the
// actions rather than squeezed beside them, so a multi-split summary stays on one or two
// lines instead of wrapping into a narrow column.
export const SubmitInfo = ({ children }) => (
  <Box
    data-testid='split-summary'
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      width: '100%',
      px: 1.5,
      py: 1,
      borderRadius: 1,
      backgroundColor: (theme) => lighten(theme.palette.info.main, 0.92),
      border: (theme) => `1px solid ${lighten(theme.palette.info.main, 0.7)}`,
    }}
  >
    <InfoOutlinedIcon sx={{ mr: 1, mt: '2px', fontSize: 16, color: 'info.main', flexShrink: 0 }} />
    <Typography sx={{ color: 'info.dark', fontSize: '0.85em' }}>{children}</Typography>
  </Box>
);

SubmitInfo.propTypes = {
  children: PropTypes.node.isRequired,
};

export const LabelValue = ({ label, value }) => (
  <Grid container direction='column'>
    <Grid item>
      <Typography sx={{ color: mutedLabel, fontSize: '0.85em' }}>{label}</Typography>
    </Grid>
    <Grid item>
      <Typography sx={{ fontWeight: 500, minHeight: 20 }} component='span'>
        {value}
      </Typography>
    </Grid>
  </Grid>
);

LabelValue.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
};

LabelValue.defaultProps = {
  value: '—',
};
